// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b569b887","204":"d2d56060","243":"ea05e904"}[chunkId] + ".chunk.js";
};